<!--
 * @Author: LeeHuiXian
 * @version: 
 * @Date: 2020-02-25 17:30:43
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-04-24 11:23:04
 * @FilePath: /goldenSalesMobile/src/components/VerifyCode/index.vue
 * @Description: 
 -->
<template>
  <span
    class="getAuthCode-btn"
    :class="canClick ? '' : 'disabled'"
    @click="sendVerifyCode(phone)"
  >
    {{ buttonTxt }}
  </span>
</template>

<script>
export default {
  name: 'VerifyCode',
  props: {
    phone: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      timeCounter: null,
      buttonTxt: '获取验证码',
      canClick: true
    }
  },
  destroyed() {
    clearInterval(this.timeCounter)
  },
  methods: {
    countDown(times) {
      let count = 0
      this.canClick = false
      this.timeCounter = setInterval(() => {
        count++
        this.buttonTxt = `${times - count + 1}s后重新获取`
        if (count > times) {
          this.buttonTxt = '获取验证码'
          this.canClick = true
          clearInterval(this.timeCounter)
        }
      }, 1000)
    },
    sendVerifyCode() {
      if (!this.phone) {
        this.$toast('请先输入手机号')
        return
      }
      
      if (this.canClick) {
        this.countDown(60)
        this.$emit('onGetSmsCode')
      }
    }
  }
}
</script>

<style>

</style>
